__turbopack_context__.v({
  "container": "style-module-scss-module__t7Keoa__container",
  "imageCarousel": "style-module-scss-module__t7Keoa__imageCarousel",
  "img-container": "style-module-scss-module__t7Keoa__img-container",
});
